// extracted by mini-css-extract-plugin
export default {"container":"aside_container__rCwPl"};